import styled, { css } from 'styled-components'
import { flex, flexAlign } from '../ReceivementFreshTag.style.mixins'

const darkGray = (props) => props.theme.colors.darkGray

export const Container = styled.div<{ hasBorders?: boolean, flexSize?: number }>`
    ${({ flexSize = 1, hasBorders = false }) =>
    css`
        ${flex('row', flexSize)}
        ${hasBorders
            && css`
                border-bottom: 1px solid ${darkGray};
                border-top: 1px solid ${darkGray};
            `} 
    `}
`

export const NameLabel = styled.div`
    ${flex('row', 0.0001)}
    border-right: 1px solid ${darkGray};
    padding: 8px;
`

export const Name = styled.span`
    text-orientation: mixed;
    writing-mode: vertical-lr;
    transform: rotate(180deg);
    text-align: center; 
    font-weight: bold; 
    font-size: 12px;
`

export const InformationLabel = styled.div`
    ${flex()}
    ${flexAlign('space-around', 'center')}
    padding: 6px 0px;
`

export const Description = styled.span`
    line-height: 1.5em;
    overflow: hidden;
    max-width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    text-align: center; 
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 6px;
    padding: 0 12px;
`
